function initProductCardGallery() {
  document.querySelectorAll('[data-pc-gallery]:not([data-pc-ready])').forEach((gallery) => {
    gallery.setAttribute('data-pc-ready', 'true');

    const images = gallery.querySelectorAll('[data-pc-image]');
    const dots = gallery.querySelectorAll('[data-pc-dot]');
    const productUrl = gallery.dataset.url;

    if (images.length <= 1) return;

    let index = 0;
    let startX = 0;
    let startY = 0;
    let hasMoved = false;

    function showImage(newIndex) {
      index = Math.max(0, Math.min(newIndex, images.length - 1));

      images.forEach((image, i) => {
        image.classList.toggle('is-active', i === index);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        showImage(i);
      });
    });

    gallery.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      hasMoved = false;
    }, { passive: true });

    gallery.addEventListener('touchend', (e) => {
      const diffX = startX - e.changedTouches[0].clientX;
      const diffY = startY - e.changedTouches[0].clientY;

      if (Math.abs(diffX) > 30 && Math.abs(diffX) > Math.abs(diffY)) {
        hasMoved = true;
        if (diffX > 0) showImage(index + 1);
        if (diffX < 0) showImage(index - 1);
      }
    });

    gallery.addEventListener('click', (e) => {
      if (e.target.closest('[data-pc-dot]')) return;
      if (e.target.closest('.pc-quick-add')) return;
      if (hasMoved) return;
      if (productUrl) window.location.href = productUrl;
    });

    showImage(0);
  });
}

function initPcQuickAdd() {
  document.querySelectorAll('.pc-quick-add:not([data-pc-ready])').forEach((form) => {
    form.setAttribute('data-pc-ready', 'true');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const formData = new FormData(form);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) return;

      const parsedState = await response.json();
      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.href = '/cart';
      }
    });
  });
}

function initPcCards() {
  initProductCardGallery();
  initPcQuickAdd();
}

window.addEventListener('load', initPcCards);
document.addEventListener('shopify:section:load', initPcCards);

const pcObserver = new MutationObserver(() => {
  initPcCards();
});

pcObserver.observe(document.body, {
  childList: true,
  subtree: true
});